import TimelineItemCard from "@/components/discussion/TimelineItemCard.vue";
import PageLoading from "@/components/discussion/post/PageLoading.vue";
import Vue from "vue";
export default {
    components: {
        TimelineItemCard,
        "page-loading": PageLoading,
    },
    props: ["items"],
    data: () => ({
        posts: [],
        currentPage: 1,
        maxPage: 0,
        lastFetch: 0,
        pageLoad: false,
        ownerOrAdmin: false
    }),
    mounted() {
        this.fetchPost();
    },
    computed: {
        courseId() {
            return this.$route.params.id;
        },
        updateDiscusstionPostList() {
            console.log("compute Discusstion")
            return this.$store.getters.updateDiscusstionPostList;
        },
    },
    methods: {
        fetchMorePost() {
            this.currentPage++;
            this.fetchPost();
        },
        fetchPost() {
            // this.$store.dispatch("fetchPost");
            this.pageLoad = true;
            const url = this.$store.getters.urlQueryParameter(
                `${this.$store.state.api}/post/list`,
                {
                    idcourse: this.courseId,
                    limit: 10,
                    page: this.currentPage,
                    web: true,
                    sortby: -1,
                    sort: "created_at",
                }
            );

            Vue.axios
                .get(url, this.$store.getters.requestHeaders)
                .then((res) => {
                    if (res.data.status) {
                        this.maxPage = res.data.result.maxPage;
                        if (res.data.result.maxPage > this.lastFetch) {
                            this.lastFetch = this.currentPage;
                            this.posts.push(...res.data.result.data);
                            this.ownerOrAdmin = res.data.result.ownerOrAdmin || false
                        } else {
                            this.lastFetch = res.data.result.maxPage;
                            this.currentPage = res.data.result.maxPage;
                        }
                    }
                    this.pageLoad = false;
                })
                .catch((err) => { })
                .finally(() => { });
        },
    },
    watch: {
        updateDiscusstionPostList(newValue) {
            console.log("update Discusstion", newValue)
            if(newValue.editId){
                let fondEditPostIndex = this.posts.findIndex(post=> post._id == newValue.editId)
                if(fondEditPostIndex > -1 ) {
                    this.posts[fondEditPostIndex] = newValue
                    this.$forceUpdate()
                }
            } else if (newValue.deleteId){
                let fondDeletePostIndex = this.posts.findIndex(post=> post._id == newValue.deleteId)
                if(fondDeletePostIndex > -1 ) {
                    this.posts.splice(fondDeletePostIndex, 1)
                    this.$forceUpdate()
                    console.log("delete",this.posts.length)
                }
            } else {
                this.posts.unshift(newValue);
            }
            
        },
    },
};